import replace from 'lodash/replace';

import { organizationQueryKey } from '@cast/constants';

export const applyYamlPreview = (code: string, orgId?: string): string => {
  const token = code.match(/Token\s[^"]+/);
  const yaml = code.match(/agent[^"]+/);

  if (!yaml || !token) {
    return code;
  }

  const urlParams = new URLSearchParams({
    ...(orgId ? { [organizationQueryKey]: orgId } : {}),
    yaml: yaml[0],
    token: token[0],
  });

  return replace(
    code,
    /https[^"]+/,
    (string) =>
      `<a href=/yaml-preview?${urlParams} target="_blank" rel="noopener noreferrer">${string}</a>`
  );
};
